/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Bulk_TitleInputs */



/**
* | output |
* | --- |
* | "{count} pending actions" |
*
* @param {Chat_Tool_Bulk_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_title = /** @type {((inputs: Chat_Tool_Bulk_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} ausstehende Aktionen`)
	return /** @type {LocalizedString} */ (`${i?.count} pending actions`)
});